export enum FeedType {
  forage = 'forage',
  grain = 'grain',
  supplement = 'supplement',
}

export enum Status {
  active = 'active',
  inactive = 'inactive',
  pending = 'pending',
}

export enum Role {
  user = 'user',
  admin = 'admin'
}

export enum validateTrigger {
  onBlur= 'onBlur',
  onChange= 'onChange',
}

export enum GenderType {
  male = 'male',
  female = 'female',
  'prefer-not-to-say' = 'Prefer not to say'
}

export enum FrequencyEnum {
  none = 'Free',
  'weekly.1' = 'Weekly 1 horse',
  'weekly.3' = 'Weekly 3 horses',
  'weekly.5' = 'Weekly 5 horses',
  'weekly.10' = 'Weekly 10 horses',
  'weekly.20' = 'Weekly 20 horses',
  'weekly.30' = 'Weekly 30 horses',
  'weekly.50' = 'Weekly 50 horses',
  'weekly.75' = 'Weekly 75 horses',
  'weekly.75plus' = 'Weekly 75+ horses',
  'annual.1' = 'Annual 1 horse',
  'annual.3' = 'Annual 3 horses',
  'annual.5' = 'Annual 5 horses',
  'annual.10' = 'Annual 10 horses',
  'annual.20' = 'Annual 20 horses',
  'annual.30' = 'Annual 30 horses',
  'annual.50' = 'Annual 50 horses',
  'annual.75' = 'Annual 75 horses',
  'annual.75plus' = 'Annual 75+ horses',
}

export enum HorseSlotsEnum {
  'weekly.1' = '1',
  'weekly.3' = '3',
  'weekly.5' = '5',
  'weekly.10' = '10',
  'weekly.20' = '20',
  'weekly.30' = '30',
  'weekly.50' = '50',
  'weekly.75' = '75',
  'weekly.75plus' = '99',
}

export enum SubscriptionTypeEnum {
  none = 'None',
  weekly = 'Weekly',
  annual = 'Annual'
}

export type IFrequency = keyof typeof FrequencyEnum;

export interface Option {
  value: string | boolean | number;
  label: string | JSX.Element;
  disabled?: boolean;
}

export interface PagingDataResponse<T> {
  data: T[]
  meta: {
    totalItems: number,
    itemsPerPage: number,
    totalPages: number,
    currentPage: number,
  }
}

export interface Horses {
  id: string
  name: string
  imageUrl: string
  dateOfBirth: string
  weight: Weight
  gender: Gender
  breed: Breed
  discipline: Discipline
  activityLevel: ActivityLevel
  createdAt: string
  updatedAt: string
}

export interface Weight {
  id: string
  onDate: string
  value: number
  neckSize: number
  girthSize: number
  bodyLength: number
  height: number
  createdAt: string
  updatedAt: string
}

export interface Gender {
  value: string,
  label: string
}

export interface Breed {
  id: string
  name: string
}

export interface Discipline {
  id: string
  name: string
}

export interface ActivityLevel {
  id: string
  name: string
}

export interface Country {
  id: string
  name: string
}

export type RequiredKeys<T> = { [K in keyof T]-?: T extends { [K1 in K]: any } ? K : never}[keyof T]

export interface ErrorData {
  statusCode: number
  message: string[]
  error: string
}

export interface ResponseError {
  status: number
  data: ErrorData
}
